import { Mutation, MutationTree } from "vuex";
import {
  ChannelChangeMutation,
  ChannelChangeState
} from "@/components/channelChange/types";

export const mutations: MutationTree<ChannelChangeState> &
  Record<ChannelChangeMutation, Mutation<ChannelChangeState>> = {
  [ChannelChangeMutation.SetChannelNumber](state, digit: number) {
    state.channelNumber.push(digit);
  },
  [ChannelChangeMutation.ClearChannelNumber](state) {
    state.channelNumber = [];
  },
  [ChannelChangeMutation.SetSource](state, src: string) {
    state.source = src;
  },
  [ChannelChangeMutation.SetOffset](state, offset: number) {
    state.offset = offset;
  },
  [ChannelChangeMutation.SetChannelChange](state, showChannelChange: boolean) {
    state.showChannelChange = showChannelChange;
  },
  [ChannelChangeMutation.SetChannelId](state, channelId: number) {
    state.channelId = channelId;
  }
};
